import * as API from '@/services/API';

export default {
  list({ commit, dispatch }, opportunityId) {
    return API.apiClient
      .get('/opportunities/' + opportunityId + '/files')
      .then((response) => {
        commit('SET_FILE_LIST', response.data);
        return response.data;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  add({ commit }, [opportunityId, file]) {
    return API.apiClient
      .post('/opportunities/' + opportunityId + '/files', file)
      .then((response) => {})
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },

  delete({ commit }, [opportunityId, fileId]) {
    return API.apiClient
      .delete('/opportunities/' + opportunityId + '/files/' + fileId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
  show({ commit, dispatch }, [opportunityId, fileId]) {
    return API.apiClient
      .get('/opportunities/' + opportunityId + '/files/' + fileId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        commit('SET_ERROR', error, { root: true });
      });
  },
};
